/**
 * Endpoint #24 — Metrics mode, all sections (§8.4-§8.10).
 *
 * Every section is `{state, reason?, data, tooltip}`; every headline figure is an `Explained`
 * so the client renders strings and plots `value` only (§12.5). Chart geometry arrays (series
 * buckets, heatmap days, day×hour cells) carry raw numbers on purpose — plotting is rendering.
 */
import { z } from 'zod';
import { BUCKET_GRANULARITIES, METRIC_KEYS, } from '../enums.js';
import { ViewFilterParamsSchema } from './common.js';
export const METRICS_SECTIONS = [
    'overview',
    'postingSchedule',
    'followerGrowth',
    'typeBreakdown',
    'bestTimes',
    'topPosts',
];
/* ----------------------------------------------------------------- request */
const SectionsParamSchema = z
    .string()
    .transform((raw) => raw
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0))
    .pipe(z.array(z.enum(METRICS_SECTIONS)).min(1));
/** #24 `GET /api/views/:t/:id/metrics` */
export const MetricsQuerySchema = ViewFilterParamsSchema.extend({
    topMetric: z.enum(METRIC_KEYS).default('reactions'),
    /** Subset of sections to compute; omitted → all six. */
    sections: SectionsParamSchema.optional(),
    /** Override the automatic bucket granularity (§8.5). */
    granularity: z.enum(BUCKET_GRANULARITIES).optional(),
});
//# sourceMappingURL=metrics.js.map